export const HEADER_LANGUAGE_DROPDOWN_OPEN = 'header_language_dropdown_open';
export const HEADER_LANGUAGE_SWITCH = 'header_language_switch';
